/* eslint-disable */
import session from './session';

export default {
    getCityList(filter) {
        return session.get(`address/city/${filter}`);
    },
    getCity(id) {
        return session.get(`address/city/${id}/`);
    },
    deleteCity(id) {
        return session.delete(`address/city/${id}/`);
    },
    createCity(data) {
        return session.post(`address/city/`, data);
    },
    updateCity(id, data) {
        return session.patch(`address/city/${id}/`, data );
    },
};